// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__HPHOB","show":"LoadingOverlay_show__LBaHM","text":"LoadingOverlay_text__2I2Rh"};